import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, Typography } from '@mui/material';
import { getItemLocalStorage } from 'hooks/useLocalStorage';
import { useState, useEffect, useRef } from 'react';
import ConfirmModal from 'utils/ConfirmModal';
import { useSelector } from 'store';

// ==============================|| NAVIGATION - SCROLL TO TOP ||============================== //

const DisconnectedModal = () => {
  const [open, setOpen] = useState(false);
  const socketState = useSelector((state) => state.socket);
  const accessToken = getItemLocalStorage('accessToken');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleReconnect = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (!socketState.connected && !!accessToken) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        if (!socketState.connected) setOpen(true);
      }, 5000);
    } else if (socketState.connected) {
      setOpen(false);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socketState]);

  return (
    <Box
      zIndex={'100000'}
      width={'400px'}
    >
      <ConfirmModal
        open={open}
        onConfirm={handleReconnect}
        title={<Typography variant="h5">Sua conexão foi perdida</Typography>}
        description={
          <Box
            width={'100%'}
            minWidth={{ md: '300px', lg: '400px' }}
            textAlign={'center'}
          >
            <WifiOffIcon
              color="error"
              sx={{ fontSize: '10rem' }}
            />
          </Box>
        }
        confirmMesssage="Reconectar"
        hiddenCloseButton
      />
    </Box>
  );
};

export default DisconnectedModal;
